

































































































































import Vue, { PropOptions } from 'vue';
import Moment from 'moment';
import * as models from '@/class/models/typed/alert';

export default Vue.extend({
  name: 'MonthlyReport',
  props: {
    monthlyReportData: {
      agreement36List: [],
      intervalList: [],
      bannedAppList: [],
    } as PropOptions<models.IMonthlyReport>,
  },
  data() {
    return {
      // inputStrPrams: '',
      // inputStr: '',
      // kekka: '',
    };
  },
  methods: {
    // formatDate(date: string, format: string) {
    //   return Moment(new Date(date)).format(format);
    // },
    outputWrapper(text: string) {
      return text !== '' ? text : '-';
    },
    /* デバッグ用
    keisan() {
      let str = this.inputStr;
      let prams = eval(this.inputStrPrams);
      let dbName = '';
      dbName = dbName !== "" ? dbName + '.' : '';
      str = str.replaceAll("\`log\`", dbName + "log");
      str = str.replaceAll("\`user\`", dbName + "user");
      str = str.replaceAll("\`device\`", dbName + "device");
      str = str.replaceAll("\`workstyle\`", dbName + "workstyle");
      str = str.replaceAll("\`account\`", dbName + "account");
      str = str.replaceAll("custom_holiday", dbName + "custom_holiday");
      str = str.replaceAll("\`", "");
      prams.forEach((v) => {
        if (typeof v === 'string') {
          str = str.replace("?", "\"" + v +"\"");
        } else {
          str = str.replace("?", v);
        }
       });
      this.kekka = str;
    },*/
  },
});
